import { useCallback } from 'react';

import { useTranslation } from 'modules/i18n';

import translation from './useFormatDayOfWeek.translation';

export function useFormatDayOfWeek(): (day: string) => string {
  const { t, keys } = useTranslation(translation);

  return useCallback(
    day => {
      const dayOfWeek: Record<string, string> = {
        Su: t(keys.sunday),
        Mo: t(keys.monday),
        Tu: t(keys.tuesday),
        We: t(keys.wednesday),
        Th: t(keys.thursday),
        Fr: t(keys.friday),
        Sa: t(keys.saturday),
      };

      return dayOfWeek[day] ?? '';
    },
    [keys, t],
  );
}
